exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/carrier/all/carrier.all.scss
// module id = 1018
// module chunks = 1